!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? t(exports, require("react"), require("@material-ui/core"), require("@material-ui/core/styles"), require("downshift")) : "function" == typeof define && define.amd ? define(["exports", "react", "@material-ui/core", "@material-ui/core/styles", "downshift"], t) : t((e = e || self)["suggestion-field"] = {}, e.React, e.core, e.styles, e.Downshift);
}(this, function (e, t, r, n, o) {
  "use strict";

  var i = "default" in t ? t.default : t;
  o = o && Object.prototype.hasOwnProperty.call(o, "default") ? o.default : o;

  var _l = function l() {
    return (_l = Object.assign || function (e) {
      for (var t, r = 1, n = arguments.length; r < n; r++) for (var o in t = arguments[r]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);

      return e;
    }).apply(this, arguments);
  };

  e.SuggestionField = function (e) {
    var a = e.items,
        u = e.icon,
        s = e.name,
        c = e.helper,
        p = e.onChange,
        f = e.onSelect,
        d = e.value,
        m = e.errorText,
        g = e.label,
        y = e.size,
        h = function (e, t) {
      var r = {};

      for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);

      if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var o = 0;

        for (n = Object.getOwnPropertySymbols(e); o < n.length; o++) t.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (r[n[o]] = e[n[o]]);
      }

      return r;
    }(e, ["items", "icon", "name", "helper", "onChange", "onSelect", "value", "errorText", "label", "size"]),
        v = n.useTheme(),
        b = t.useState(!1),
        O = b[0],
        x = b[1],
        w = t.useState(""),
        P = w[0],
        E = w[1];

    t.useEffect(function () {
      d && E(d.description);
    }, [d]);
    var S = u ? i.cloneElement(u, {
      color: O ? "action" : "disabled"
    }) : null,
        j = n.makeStyles(function (e) {
      return n.createStyles({
        suggestion: {
          "&:hover": {
            backgroundColor: e.palette.grey[300],
            cursor: "pointer"
          }
        }
      });
    })();
    return i.createElement(o, {
      itemToString: function itemToString(e) {
        return e ? e.description : "";
      },
      onChange: function onChange(e) {
        f && f(e);
      }
    }, function (e) {
      var t = e.isOpen,
          n = e.getInputProps,
          o = e.getMenuProps,
          u = e.getItemProps,
          f = e.highlightedIndex;
      return i.createElement("div", null, i.createElement(r.TextField, _l({
        name: s,
        label: g,
        InputProps: {
          startAdornment: S
        },
        error: !!m,
        helperText: m
      }, n({
        onChange: function onChange(e) {
          E(e.target.value), p && p(e);
        },
        onFocus: function onFocus() {
          return x(!0);
        },
        onBlur: function onBlur() {
          return x(!1);
        },
        ref: void 0,
        value: P,
        color: void 0
      }), h, {
        size: y
      })), t && a.length ? i.createElement(r.Box, {
        style: {
          position: "relative",
          width: "100%",
          marginTop: m && c ? -20 : 0
        }
      }, i.createElement(r.Paper, {
        elevation: 2,
        style: {
          position: "absolute",
          zIndex: 9999,
          width: "100%"
        }
      }, i.createElement(r.List, _l({}, o()), a.map(function (e, t) {
        return i.createElement(r.ListItem, _l({
          key: e.id,
          className: j.suggestion
        }, u({
          item: e
        }), {
          style: {
            backgroundColor: f === t ? v.palette.grey[300] : "white"
          }
        }), e.description);
      })))) : null);
    });
  }, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});